import { RouteRecordRaw } from 'vue-router';
import { featureFlags } from '@/featureFlags';

const isRenewal = featureFlags.ANDEV_10553_ONBOARDING_RENEWAL;

const stepRoutes: RouteRecordRaw[] = [
  {
    path: 'welcome',
    component: () =>
      isRenewal
        ? import('@/components/onboarding/next/welcome.vue')
        : import('@/components/onboarding/welcome.vue'),
    name: 'onboardingWelcome',
    meta: { title: '情報収集エージェントの紹介' },
  },
  {
    path: 'setup_profile',
    component: () =>
      isRenewal
        ? import('@/components/onboarding/next/setup-profile.vue')
        : import('@/components/onboarding/setup-profile.vue'),
    name: 'onboardingSetupProfile',
    meta: { title: '注目サマリーの設定' },
  },
  {
    path: 'setup_theme',
    component: () =>
      isRenewal
        ? import('@/components/onboarding/next/setup-theme.vue')
        : import('@/components/onboarding/setup-theme.vue'),
    name: 'onboardingSetupTheme',
    meta: { title: 'テーマの設定' },
  },
  {
    path: 'setup_marks',
    component: () =>
      isRenewal
        ? import('@/components/onboarding/next/setup-marks.vue')
        : import('@/components/onboarding/setup-marks.vue'),
    name: 'onboardingSetupMarks',
    meta: { title: 'パーソナルニュースの設定' },
  },
  {
    path: 'setup_follow_list',
    component: () =>
      isRenewal
        ? import('@/components/onboarding/next/setup-follow-list.vue')
        : import('@/components/onboarding/setup-follow-list.vue'),
    name: 'onboardingSetupFollowList',
    meta: { title: 'フォローリストの設定' },
  },
];

const featuresRoute: RouteRecordRaw = {
  path: 'features',
  component: () => import('@/components/onboarding/features.vue'),
  name: 'onboardingFeatures',
  meta: { title: '主要機能の紹介' },
};

export const onboardingRouteConfig: RouteRecordRaw = {
  path: '/onboarding',
  name: 'onboarding',
  component: () => import('@/components/layouts/onboarding.vue'),
  meta: { accessScope: 'information_retrieval' },
  children: isRenewal
    ? [
        // ステップ間で進捗バーのトランジションを効かせるため、フレームを親ルートにして再マウントさせない
        {
          path: '',
          component: () =>
            import('@/components/onboarding/next/onboarding-frame.vue'),
          children: stepRoutes,
        },
        featuresRoute,
      ]
    : [stepRoutes[0], featuresRoute, ...stepRoutes.slice(1)],
};
